/**
 * @generated SignedSource<<80ab0e80e4eb6e24c800c20f1c3a4b1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion$data = {
  readonly content: string;
  readonly contentForDisplay: string | null;
  readonly id: string;
  readonly " $fragmentType": "AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion";
};
export type AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion$key = {
  readonly " $data"?: AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentForDisplay",
      "storageKey": null
    }
  ],
  "type": "SuggestedQuestion",
  "abstractKey": null
};

(node as any).hash = "ab245be77dec079eaea1285c91dfed01";

export default node;
